import * as MapHelper from '../../helpers/mapHelper';

export const getTargetUri = (item) => {
    if (item.entity_id) {
        return MapHelper.getTargetUri(item);
    }
    return null;
};

export const getPriceRangeLabel = (item) => {
    if (item && item.price_range) {
        const range = item.price_range;

        if (range) {
            const minAmount = range.amount_min;
            const maxAmount = range.amount_max;

            if (minAmount > -1) {
                if (minAmount === maxAmount) {
                    return `$${Math.floor(minAmount)}`;
                }
                return `$${Math.floor(minAmount)} - $${Math.floor(maxAmount)}`;
            }
        }
    }
    return null;
};

export const getPriceRangeUnit = (item) => {
    if (item && item.price_range) {
        const range = item.price_range;

        if (range) {
            return range.per_unit
        }
    }
    return null;
};

